import { Badge, BadgeProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

const COLORS: Record<string, BadgeProps["color"]> = {
  OPEN:        "red",
  IN_PROGRESS: "orange",
  ESCALATED:   "grape",
  RESOLVED:    "green",
  CLOSED:      "gray",
}

interface Props {
  status: string | null | undefined
  size?: BadgeProps["size"]
}

export function ExceptionStatusBadge({ status, size = "sm" }: Props) {
  const { t } = useTranslation("delivery")
  if (!status) {
    return (
      <Badge size={size} variant="light" color="gray">
        —
      </Badge>
    )
  }
  return (
    <Badge size={size} variant="light" color={COLORS[status] ?? "gray"}>
      {t(`failed.exStatus.${status}`, { defaultValue: status })}
    </Badge>
  )
}
